import React, { useEffect, useRef, useState } from "react";
import "../styles/uiCss/StickyRolls.css";
import useIsMobile from "../components/isMobile/IsMobile";
import { useNavigate } from "react-router-dom";

const StickyScrolls = ({ content, contentClassName }) => {
  const [activeCard, setActiveCard] = useState(0);
  const navigate = useNavigate();
  const [backgroundGradient, setBackgroundGradient] = useState("");
  const containerRef = useRef(null);
  const isMobile = useIsMobile(768);

  const linearGradients = [
    "linear-gradient(to bottom right, #06b6d4, #10b981)", // cyan to green
    "linear-gradient(to bottom right, #ec4899, #6366f1)", // pink to indigo
    "linear-gradient(to bottom right, #f97316, #eab308)", // orange to yellow
  ];

  // Detect active card based on scroll position
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const scrollFraction = scrollTop / (scrollHeight - clientHeight);
      const newIndex = Math.floor(scrollFraction * content.length);
      setActiveCard(Math.min(newIndex, content.length - 1));
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [content]);

  // Update background gradient
  useEffect(() => {
    setBackgroundGradient(linearGradients[activeCard % linearGradients.length]);
  }, [activeCard]);

  return (
    <div
      className="sticky-scroll-container"
      ref={containerRef}
      style={{ background: "#000" }}
    >
      <div className="sticky-scroll-content">
        {content.map((item, index) => (
          <div
            key={index}
            className={`scroll-item ${activeCard === index ? "active" : ""}`}
          >
            <h2
              style={{
                fontFamily: "Nexa-Bold",
                fontSize: isMobile ? 20 : 30,
              }}
            >
              {item.title}
            </h2>
            <p
              style={{
                fontFamily: "Nexa-Regular",
                fontSize: isMobile ? 14 : 16,
              }}
            >
              {item.description}
            </p>
          </div>
        ))}
        <div
                    className="phase-button"
                    onClick={() => {
                      navigate(`/courses`);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                   Book a demo!
                  </div>
      </div>
     
      <div className={`sticky-image ${contentClassName || ""}`}>
        <img
          src={content[activeCard]?.content}
          alt="visual"
          className="image-cover"
        />
      </div>
    </div>
  );
};

export default StickyScrolls;
